import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mb-5 pt-3" }
const _hoisted_2 = { class: "col-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Start time", -1)
const _hoisted_4 = { class: "start" }
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = { class: "col-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "End time", -1)
const _hoisted_8 = { class: "start" }
const _hoisted_9 = { class: "text-muted" }
const _hoisted_10 = { class: "col-2 d-flex align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("I was late")
const _hoisted_12 = { class: "col-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Comment:", -1)
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "col-2" }
const _hoisted_16 = { class: "d-flex flex-fill justify-content-end flex-row h-100 align-items-center" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Report ")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReportsTimeSelector = _resolveComponent("ReportsTimeSelector")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_ReportsTimeSelector, {
            modelValue: _ctx.reportedHours.startTime,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reportedHours.startTime) = $event)),
            "date-time-string": _ctx.shiftSlot.start,
            "minimum-start-time": _ctx.minimumStartTime
          }, null, 8, ["modelValue", "date-time-string", "minimum-start-time"]),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.shiftSlot.start), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_ReportsTimeSelector, {
            modelValue: _ctx.reportedHours.endTime,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reportedHours.endTime) = $event)),
            "date-time-string": _ctx.shiftSlot.end
          }, null, 8, ["modelValue", "date-time-string"]),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.endLabel), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_checkbox, {
          modelValue: _ctx.reportedHours.iwasLate,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reportedHours.iwasLate) = $event))
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_input, {
            class: "w-100",
            placeholder: "Enter comment...",
            modelValue: _ctx.reportedHours.comment,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.reportedHours.comment) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-danger",
            disabled: 
              _ctx.isAwaitingResponse.isLoading &&
                _ctx.isAwaitingResponse.indexes.includes(_ctx.index)
            ,
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveData && _ctx.saveData(...args)))
          }, [
            _withDirectives(_createElementVNode("div", _hoisted_18, null, 512), [
              [_vShow, 
                _ctx.isAwaitingResponse.isLoading &&
                  _ctx.isAwaitingResponse.indexes.includes(_ctx.index)
              ]
            ]),
            _hoisted_19
          ], 8, _hoisted_17)
        ])
      ])
    ]),
    _hoisted_20
  ]))
}